var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfitSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 63,
    viewBox: "0 0 29 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5869 28.4663L23.8999 12.7187L14.8129 12.8199L10.9779 12.8592L2.3728 34.6388L0.4944 39.2082L2.3728 38.8973L10.1259 37.6202L0 62.4111H0.0580978L25.7839 28.133L17.5869 28.4663Z",
    fill: "#EC4E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6241 0L11.6851 10.3579L24.3621 10.371L28.1281 0.147942L15.6241 0Z",
    fill: "#EC4E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfitSmall);
export default __webpack_public_path__ + "static/media/unfit_small.c627c1cabbc28eee8c5e02a48a8795f9.svg";
export { ForwardRef as ReactComponent };